import { Col, Modal, Row } from "react-bootstrap";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import TableGrouping from "../../components/table-grouping/TableGrouping";
import { GroupButton } from "../../components/GroupButton";
import { REPORT_DE_XUAT_COLUMNS, REPORT_NANG_LUONG_COLUMNS } from "../constants/reportConsts";
import { useContext } from "react";
import AppContext from "../../../AppContext";

const DialogPrintReportProposal = (props: any) => {
  const {
    open,
    columns = [],
    dateSearch = {},
    data = [],
    handleClose = () => { }
  } = props;

  const { setPageLoading } = useContext(AppContext);
  const { lang } = useMultiLanguage();

  const handlePrint = () => {
    let style = `
          @page {
            size: A4 landspace;
            margin: 15mm;
          }

          @media print {
            html, body {
                margin: 0;
                padding: 0;
                font-family: "Times New Roman", serif;
                color: #000;
            }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; text-align: center; padding: 0px 5px; }
            
            .container-title {
                position: relative;
                padding-top: 1.25rem;
                margin-bottom: 1.25rem;
            }
    
            .title-table-print {
                font-weight: bold;
                text-transform: uppercase;
                font-size: 1.75rem;
                text-align: center;
                margin: 0px;
            }

            .title-time-print {
                font-style: italic;
                font-size: 1.15rem;
                margin: 0px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .container-header {
                display: flex;
                justify-content: space-between;
                margin-left: 1.25rem;
                margin-top: 3rem;
            }

            .title-header {
                font-weight: bold;
                font-size: 1.35rem;
                text-align: center;
                margin: 0px;
            }

            .text-left {
                text-align: left !important;
            }
            
            .container-footer {
                margin-top: 30px;
                margin-bottom: 100px;
            }

            .time-footer {
                text-align: end;
                font-style: italic;
                margin-bottom: 10px;
            }

            .footer {
                display: flex;
                justify-content: space-between;
            }
            
            .title-footer {
                text-align: center;
                font-weight: bold;
                margin: 0;
            }

            .span-footer {
                text-align: center;
                font-style: italic;
                margin: 0;
            }

            .text-uppercase {
                text-transform: uppercase;
            }

            @page {
                margin: 20px !important; 
            }
          }
        `;
    const content = document.getElementById("content-print");
    if (content) {
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Bang_Bao_Cao_Nang_Luong</title>
              <style>${style}</style>
            </head>
            <body onload="window.print(); window.close();">
              ${content.innerHTML}
            </body>
          </html>
        `);
        printWindow.document.close();
      }
    }
  };

  if (!open) return <></>

  return (
    <Modal
      show={open}
      onHide={() => {
        handleClose();
      }}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {lang("PRINT_TIMEKEEPING_TABLE")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="spaces py-0">
        <iframe
          id="ifmcontentstoprint"
          style={{
            height: "0px",
            width: "0px",
            position: "absolute",
          }}
        ></iframe>
        <div className="time-sheets-print">
          <Row id="content-print" className="px-4">
            <Col xs={12}>
              <div className="container-title relative pt-5 mb-3">
                <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>
                  {REPORT_DE_XUAT_COLUMNS.find((report) => report.tab === dateSearch.tab)?.name || ""}
                </p>
              </div>
              <TableGrouping
                id="reportDetail"
                columns={columns || []}
                data={data || []}
                className="table-custom"
                showTotalRow={false}
                columnsTotal={[]}
                prefixDataField="data"
                prefixTitleField="phongBanText"
              />
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <GroupButton
          handleEvent={() => {
            handlePrint();
          }}
        >
          {lang("BTN.PRINT")}
        </GroupButton>
        <GroupButton
          type="btn-cancel"
          handleCloseUpdateDialog={() => {
            handleClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}
export default DialogPrintReportProposal;